import React from "react";
import Typography from "../../components/typography/Typography";
import Button from "../../components/ui/Button";
import { useNavigate } from "react-router-dom";

export default function AptitudeTest() {

  const navigate = useNavigate();
  return (
    <section className="h-screen w-full flex flex-col justify-center items-center containerLayout gap-3">
      <Typography variant="h3-title">
        Welcome To Pronterra's Aptitude Test
      </Typography>
      <Typography variant="h4-title">(Description)</Typography>
      <Button onClick={() => navigate("/aptitude-test/questions")}>Start</Button>
    </section>
  );
}
